
import './formDetalle.scss'
import { useState, useEffect, useContext } from "react";
import { InventariosDetFormContext } from '../../../../../context/inventariosDet/InventariosDetContext';
import loadingGif from '../../../../../assets/uploading.gif';
import ArticulosDepositoModal from '../../../../articulosDeposito/articulosDepositoModal/articulosDepositoModal';
import ConfirmationDialog from "../../../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../../../components/dialogs/ErrorDialog";
import { ArticulosDepositoContext } from '../../../../../context/articulosDeposito/ArticulosDepositoContext';

export const FormDetalle = ({
  ajuid,
  depoid,
  iddet,
  addItem,
  getItem,
  updateItem,
  arrayDetalle,
  closeModal
}) => {

  const {
    report,
    getArticuloByIdData,
  } = useContext(InventariosDetFormContext);
  const {
    getArtDepositoPanelData,
  } = useContext(ArticulosDepositoContext);
  const [title, setTitle] = useState('');
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [searchIdArt, setSearchIdArt] = useState();
  const [searchDescArt, setSearchDescArt] = useState();
  const [selectedRow, setSelectedRow] = useState();

  // Vista Previa
  const [uploadFormError, setUploadFormError] = useState('');  // Para el mensaje de error de imagen
  // estado de carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  // estado de edicion o creacion
  const [estadoForm, setEstadoForm] = useState('');

  // Estado para controlar la apertura de los diálogos
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      if (iddet) {
        setTitle("Modificar Artículo");
        const detalleEnArray = arrayDetalle.find((item) => item.ajd_id === iddet);
        if (detalleEnArray) {
          if (detalleEnArray) {
            setForm((prevForm) => ({
              ...prevForm,
              art_descripcion: detalleEnArray?.oferta_Art?.art_descripcion || prevForm.art_descripcion || "",
              ...detalleEnArray, // Usa detalleEnArray correctamente si es un objeto plano
            }));
            setEstadoForm(1);
          }
          setEstadoForm(1);
        }
      }
      else {
        setTitle("Agregar Artículo");
      }
    };

    fetchData(); // Llamar a la función asíncrona dentro de useEffect
  }, [ajuid, iddet]);

  const handleSelectArticulo = async (art_id, art_codigo, art_descripcion) => {
    const stockactual = await getArtDepositoPanelData(art_id, null, 1, 1);
    setForm((prevForm) => ({
      ...prevForm,
      art_id: art_id,
      art_codigo: art_codigo,
      art_descripcion: art_descripcion,
      ajud_art_id: art_id,
      ajud_stockactual: stockactual?.ajustesDeposito?.[0]?.ade_cantidadexi || 0
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => {
      let updatedForm = { ...prevForm };
      validateInput(name, value);
      updatedForm[name] = value;
      return updatedForm;
    });
  };

  const validateInput = (name, value) => {
    const regex = /^\d+(\.\d{1,3})?$/;
    let roundedValue = value;

    // Si es un número válido con más de 3 decimales
    if (!isNaN(value) && value !== "") {
      const floatValue = parseFloat(value);
      roundedValue = parseFloat(floatValue.toFixed(3)); // redondea a 3 decimales

      // Actualizá el form con el valor redondeado
      setForm((prevForm) => ({
        ...prevForm,
        [name]: roundedValue,
      }));

      // Validación con regex para hasta 3 decimales
      if (!regex.test(roundedValue.toString())) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: 'Debe ser un número con hasta 3 decimales.',
        }));
        return false;
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: '',
        }));
        return true;
      }
    }
    return true;
  };

  const validateForm = async () => {
    let formErrors = {};

    if (!form.art_codigo || form.art_codigo.trim() === '') {
      formErrors.art_codigo = 'El Código es obligatorio';
    }

    if (form.ajud_stockreelevado === undefined || form.ajud_stockreelevado === '') {
      formErrors.ajud_stockreelevado = 'Se requiere que ingrese la cantidad reelevada';
    } else if (isNaN(form.ajud_stockreelevado)) {
      formErrors.ajud_stockreelevado = 'La cantidad reelevada debe ser un número válido';
    } else if (parseFloat(form.ajud_stockreelevado) < 0) {
      formErrors.ajud_stockreelevado = 'La cantidad reelevada no puede ser negativa';
    }

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return false;
    }

    // Verificar si el artículo ya existe
    const existente = await buscarExistente();
    if (existente && !iddet) {
      formErrors.art_codigo = 'El artículo ya existe, no se puede duplicar';
      setErrors(formErrors);
      return false;
    }

    setErrors({});
    return true;
  };


  const buscarExistente = async () => {

    // Buscar en el array temporal
    const encontradoArray = arrayDetalle.find(item => item.art_id === form.art_id);

    if (encontradoArray) {
      return encontradoArray;
    }

    return null; // Devuelve null si no encuentra el elemento
  };

  const handleSendData = async () => {

    // Validar formulario
    const isFormValid = await validateForm();
    if (!isFormValid) {
      openErrorDialog("Por favor, corrige los errores antes de continuar.");
      return;
    }
    setIsSubmitting(true);
    try {
      const generateRandomId = () => {
        return Math.floor(Math.random() * 1000000) + Date.now();
      };

      // Dentro del handleSendData
      const idNuevo = generateRandomId();
      // Crear el objeto oferta_Art
      const articulos = {
        art_id: form.art_id,
        art_codigo: form.art_codigo,
        art_descripcion: form.art_descripcion,
      };
      // Nuevo objeto con oferta_Art incluido
      const newForm = {
        ...form,
        ajd_id: idNuevo,
        articulos: articulos,
        ajud_art_id: form.art_id,
      };

      if (iddet) {
        const detalleEnArray = arrayDetalle.find((item) => item.ajd_id === iddet);
        if (detalleEnArray) {
          await updateItem(detalleEnArray.ajd_id, newForm);
          setEstadoForm(1);
        }
      }
      else {
        await addItem(newForm);
      }
      resetForm();
      closeModal();
    } catch (error) {
      console.error("Error al guardar los datos:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };

  const closeErrorDialog = () => setIsErrorDialogOpen(false);


  const resetForm = () => {
    setForm({
      ajud_stockreelevado: '',
      ajud_stockactual: '',
      ajud_obs: '',
      art_codigo: '',
      art_Id: '',
      art_descripcion: '',
    });
  };

  const handleCancel = () => {
    setSelectedRow('');
    setEstadoForm(0);
    resetForm();
    closeModal();
  }; 
  return (
    <>
      <div className="topOD">
        <h3>{title}</h3>
      </div>
      <div className="new">
        <div className="newContainerOD">
          <div className="bottomOD">
            <div>
              <form >
                {/* Código de artículo */}
                <div className="formInputOD">
                  {estadoForm === 1 ? (
                    <></>
                  ) : (
                    <>
                      <label>Busqueda</label>
                      <ArticulosDepositoModal
                        handleChange={setSearchIdArt}
                        handleDescChange={setSearchDescArt}
                        descSelected={searchDescArt}
                        onSelect={handleSelectArticulo}
                        tipovista='conStock'
                        findStock={false}
                        idSelectorDepo={depoid}
                        viewInformes={false}
                      />
                    </>

                  )}
                </div>
                <div className="formInputOD">
                  <label>Codigo</label>
                  <input
                    type="text"
                    name="art_codigo"
                    value={form.art_codigo || ''}
                    placeholder="Código de un artículo"
                    className={`inputNoEditable ${errors["art_codigo"] ? 'inputError' : ''}`}
                    readOnly
                  />
                  {errors["art_codigo"] && <span className="error">{errors["art_codigo"]}</span>}
                </div>
                <div className="formInputOD" style={{ display: 'none' }}>
                  <label>ID Detalle</label>
                  <input
                    type="int"
                    name="ajud_aju_id"
                    value={form.ofcab_id || ''}
                    placeholder="Código de un artículo"
                    className={errors["ajud_aju_id"] ? 'inputError' : ''}
                    readOnly
                    hidden={true}
                  />
                  {errors["ajud_aju_id"] && <span className="error">{errors["ajud_aju_id"]}</span>}
                </div>
                {/* id del artículo */}
                <div className="formInputOD" style={{ display: 'none' }}>
                  <label>ID DEL ARrticulo</label>
                  <input
                    type="int"
                    name="art_Id"
                    value={form.art_Id || ''}
                    placeholder="Articulo"
                    className={errors["art_Id"] ? 'inputError' : ''}
                    onChange={handleInputChange}
                    hidden={true}
                  />
                  {errors["art_Id"] && <span className="error">{errors["art_Id"]}</span>}
                </div>
                {/* Descripción del artículo */}
                {iddet &&
                  <div className="formInputOD" >
                    <label>Descripcion</label>
                    <input
                      type="text"
                      name="art_descripcion"
                      value={form.art_descripcion || ''}
                      placeholder="Articulo"
                      className={`inputNoEditable ${errors["art_descripcion"] ? 'inputError' : ''}`}
                      onChange={handleInputChange}
                      readOnly
                    />
                    {errors["art_descripcion"] && <span className="error">{errors["art_descripcion"]}</span>}
                  </div>
                }

                {/* Costo + Flete */}
                <div className="formInputOD">
                  <label>Stock Actual</label>
                  <input
                    type="number"
                    name="ajud_stockactual"
                    value={form.ajud_stockactual || ''}
                    placeholder="Stock Actual"
                    className={`inputNoEditable ${errors["ajud_stockactual"] ? 'inputError' : ''}`}
                    readOnly
                  />
                  {errors["ajud_stockactual"] && <span className="error">{errors["ajud_stockactual"]}</span>}
                </div>

                {/* Precio del artículo */}
                <div className="formInputOD">
                  <label>Stock Reelevado</label>
                  <input
                    type="number"
                    step="0.001"
                    min="0"
                    name="ajud_stockreelevado"
                    value={form.ajud_stockreelevado || ''}
                    placeholder="Ingrese solo números positivos o decimales "
                    className={errors["ajud_stockreelevado"] ? 'inputError' : ''}
                    onChange={handleInputChange}
                  />
                  {errors["ajud_stockreelevado"] && <span className="error">{errors["ajud_stockreelevado"]}</span>}
                </div>

                {/* Precio del artículo */}
                <div className="formInputOD">
                  <label>Observaciones</label>
                  <textarea
                    name="ajud_obs"
                    value={form.ajud_obs || ''}
                    placeholder="Observaciones"
                    className={errors["ajud_obs"] ? 'inputError' : ''}
                    onChange={handleInputChange}
                  />
                  {errors["ajud_obs"] && <span className="error">{errors["ajud_obs"]}</span>}
                </div>

                {uploadFormError && <span className="error">{uploadFormError}</span>}

                {/* Botones */}
                <div className="btn-fieldOD">
                  <button
                    type="button"
                    className="OD-button"
                    onClick={handleSendData}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Guardando...' : 'Guardar'}
                  </button>
                  <button
                    type="button"
                    className="cancel-buttonOD"
                    onClick={handleCancel}
                    disabled={isSubmitting}
                  >
                    Cancelar
                  </button>
                </div>
              </form>

              <ErrorDialog
                isOpen={isErrorDialogOpen}
                onClose={closeErrorDialog}
                message={errorMessage}
                title=""
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormDetalle;
